import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import InputSimple, { nameDecorator, phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const BaseButton = styled(Button)`
    max-width: 200px;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
    }
`;

export const NameInput = nameDecorator(InputSimple);

export const PhoneInput = styled(phoneDecorator(InputSimple))`
    width: 87%;
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
    }
`;

export const BreakHack = styled.div`
    @media (max-width: ${wideBreakpoints.sMobile}) {
        margin-left: 5px;
    }
  
    white-space: nowrap;
    display: inline;
`;

export const ButtonLookLikeHref = styled.div`
    display: inline;
    color: ${COLORS.Link};
    ${FONTS.MediumS};
    cursor: pointer;
    margin-left: 5px;
    transition: 0.3s;
  
    &:hover {
        color: ${COLORS.Brand_Blue};
    }
`;

export const Popup = styled(DefaultPopup)`
    padding: 32px;
    display: flex;
    width: 960px !important;
    flex-direction: column;
    
    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 800px !important;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 700px !important;
    }
            
    @media (max-width: ${wideBreakpoints.sMobile}) {
        padding: 26px;
    }
    
    > * {
        margin-bottom: 20px;
    }
    > *:last-child {
        margin-bottom: unset;
    }
`;

export const ButtonsContainer = styled.div`
     display: flex;
     flex-direction: row;
     > * {
        margin-right: 12px;
        margin-top: 16px;
     }
`;

export const Title = styled.h1`
    ${FONTS.H3};
    margin-top: 0;
    margin-bottom: 10px;
`;

export const BaseContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    max-width: 570px;
    
    > *:not(:last-child) {
        margin-right: 12px;
        margin-bottom: unset;
    }

    @media (max-width: ${wideBreakpoints.mobile}){
        flex-direction: column;
        align-items: center;
        
        > * {
            width: 100%;
        }
        
        > *:not(:last-child) {
            margin-bottom: 10px;
        }
    }
`;

export const InputContainer = styled(BaseContainer)`
    min-height: 72px;
    align-items: flex-start;
`;

export const Text = styled.div`
    align-items: baseline;
`;

export const Message = styled.div<{ isError: boolean }>`
    color: ${props => props.isError ? COLORS.Error : COLORS.Success};
`;

export const Link = styled.a`
    cursor: pointer;
`;
